<template>
  <div class="d-flex align-items-center">
    <div
      @click.stop="$emit('prev')"
      :class="[
        'change-selector-icon',
        {
          '-translate-scale-1': isLangRtl,
        },
      ]"
    >
      <img src="@/assets/images/icons/arrow-icon.svg" alt="arrow-icon" />
    </div>
    <div class="selector-text" v-if="selected_view === 'daily'">
      {{
        isLangRtl
          ? formatDate(selected_date, 'dddd, Do, MMM')
          : selected_date | moment('dddd , Do , MMMM')
      }}
    </div>
    <div class="selector-text" v-if="selected_view === 'weekly'">
      {{ this.$t('week') }}
      {{ isLangRtl ? formatDate(selected_date, 'w') : selected_date | moment('W') }}
    </div>
    <div class="selector-text" v-if="selected_view === 'monthly'">
      {{ isLangRtl ? formatDate(selected_date, 'MMMM') : selected_date | moment('MMMM') }}
    </div>
    <div class="change-selector-icon" @click.stop="$emit('next')">
      <img
        src="@/assets/images/icons/arrow-icon.svg"
        alt="arrow-icon"
        :class="[
          {
            '-translate-scale-1': !isLangRtl,
          },
        ]"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['selected_date', 'selected_view'],
  emits: ['prev', 'next'],
}
</script>

<style lang="scss" scoped>
.change-selector-icon {
  cursor: pointer;
  background: var(--color-11);
  height: 28px;
  width: 28px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.75rem;
}

.selector-text {
  margin-right: 0.75rem;
  font-weight: 400;
  font-size: 16px;
  color: var(--color-17);
}
</style>
